// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".OverlappingIconGroup-base__LbuNS{display:flex}.OverlappingIconGroup-base__LbuNS>:first-child{margin-left:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "OverlappingIconGroup-base__LbuNS"
};
export default ___CSS_LOADER_EXPORT___;
